import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnCitizenIncidentDetails } from './citizen-incident-details';

/**
 * Represents a video stream with associated metadata.
 */
export class SnCitizenVideoStream extends SnModel {
  /** ID of the video. Unique for each video stream. */
  @Expose({ name: 'id' })
  public id: string;

  /** GeoLocation of the video stream. */
  @Expose({ name: 'geo_location' })
  public geoLocation: { longitude: number; latitude: number };

  /** Bearing of the video stream. */
  @Expose({ name: 'bearing' })
  public bearing: number;

  /** Source of the video. Example: "radio", "community" or "911". */
  @Expose({ name: 'source' })
  public source: string;

  /** Timestamp when the video was created in ISO format, eg: 2025-01-31T03:05:19Z */
  @Expose({ name: 'created_at' })
  public createdAt: string;

  /** Timestamp when the video was last updated in ISO format, eg: 2025-01-31T03:05:19Z */
  @Expose({ name: 'updated_at' })
  public updatedAt: string;

  /** Duration of the video in seconds. */
  @Expose({ name: 'duration_seconds' })
  public durationSeconds: number;

  /** Describes whether the HLS stream is completed. */
  @Expose({ name: 'hls_done' })
  public hlsDone: boolean;

  /** URL pointing to a still image that is the thumbnail for the video. */
  @Expose({ name: 'thumbnail_url' })
  public thumbnailURL: string;

  /** URL pointing to HLS manifest (m3u8) for this live stream. */
  @Expose({ name: 'stream_url' })
  public streamURL: string;

  /** URL pointing to the mp4 archive of this live stream. */
  @Expose({ name: 'vod_url' })
  public vodURL: string;

  /** Deletion status of the video. Can be "moderated", "user deleted" or null. */
  @Expose({ name: 'deletion_status' })
  public deletionStatus: 'moderated' | 'user deleted' | null;

  /** Information about the incident associated with this video. */
  @Expose({ name: 'incident_details' })
  @Type(() => SnCitizenIncidentDetails)
  public incidentDetails: SnCitizenIncidentDetails;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
